import { FlatBorderCard } from '@procurify/ui'
import { tint } from 'polished'
import styled, { css } from 'styled-components'

export const CatalogItemLayoutStyled = styled(FlatBorderCard)<{
  $isSelected?: boolean
}>`
  display: flex;
  flex-direction: column;
  gap: ${(props) => props.theme.space.small};
  width: 100%;
  padding: ${(props) => props.theme.space.small};
  cursor: pointer;

  transition: box-shadow 0.15s;

  ${(props) =>
    props.$isSelected
      ? css`
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
          border-color: ${tint(0.3, props.theme.colors.darkGrey)};
        `
      : css`
          border-color: ${props.theme.colors.form.field.border};
        `}

  &:hover {
    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.2);
  }

  &:focus-visible {
    outline: ${(props) => props.theme.typography.pxToRem(2)} solid
      ${(props) => props.theme.colors.primary};
    outline-offset: ${(props) => props.theme.typography.pxToRem(-2)};
  }
`
